import { OfficeWithdrawalRequestWithdrawalForm } from '@/context/services/office_withdrawal/type';
import { useTranslation } from '@/i18n';
import { FormCheckbox, Heading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { memo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../../index.module.scss';

const cx = classnames.bind(styles);

type Props = {
  control: Control<OfficeWithdrawalRequestWithdrawalForm>;
};

export const ConfirmationSection = memo(({ control }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles['section-content'])}>
      <Heading as='h4' className={cx(styles['heading'])}>
        {t('office_withdrawal.confirmation')}
      </Heading>
      <div>
        <div className={cx(styles['warning-text'])}>
          {t('office_withdrawal.confirm_point_warning')}
        </div>
        <div className={cx(styles['description-text'])}>
          {t('office_withdrawal.confirm_point_three')}
        </div>
      </div>
      <div className={cx(styles['withdrawal-input'])}>
        <FormCheckbox<OfficeWithdrawalRequestWithdrawalForm>
          control={control}
          name='confirmed'
          inputId='confirmed'
          label={t('office_withdrawal.confirmed_data_deletion')}
        />
      </div>
    </div>
  );
});

ConfirmationSection.displayName = 'ConfirmationSection';
